import { Directive, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
  selector: '[appLastClickInside]',
  exportAs: 'lastClickInside',
  standalone: false
})
export class LastClickInsideDirective {
  lastClickInside = false;
  @Output()
  lastClickInsideChange = new EventEmitter<boolean>();

  constructor(private host: ElementRef<HTMLElement>) {}

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(clickedElement: HTMLElement) {
    this.lastClickInside = this.host.nativeElement.contains(clickedElement);
    this.lastClickInsideChange.emit(this.lastClickInside);
  }
}